module.exports = __webpack_public_path__ + "assets/sushi_disabled-08986e.svg";